import React from 'react';
import PropTypes from 'prop-types';
import ReactSlider from 'rc-slider';
import classNames from 'classnames';

const Slider = props => {
  const {
    selected,
    answerOptions,
    onChange,
    className,
    extended,
    disabled,
    continuousDrag,
    continuousValues = true
  } = props;

  const selectedIndex = answerOptions.findIndex( option => option.value === selected);
  const minAmount = extended ? -1 : 0;
  const maxAmount = extended ? answerOptions.length : answerOptions.length - 1;

  const markers = answerOptions.reduce( (map, obj, index) => {
    const labelClasses = classNames({
      'rc-slider__label' : true,
      'rc-slider__label--selected' : selectedIndex === index
    });
    map[index] = <label className={labelClasses} aria-label={ obj.label }>{obj.label}</label>;
    return map;
  }, {});

  const onChangeCallback = (index) => {
    try {
      let correctedIndex = Math.round(index);
      correctedIndex = correctedIndex < 0 ? 0
        : correctedIndex >= answerOptions.length ? answerOptions.length - 1
          : correctedIndex;
      const originalValue = answerOptions[correctedIndex].value;
      onChange(originalValue, correctedIndex);
    }catch(ex) {
      console.error('Error during onChangeCallback', index, ex);
    }
  };

  const classes = classNames( className, {
    'rc-slider--active' : selectedIndex >= 0,
  });

  return <ReactSlider
    aria-label="Slide to choose a value"
    className={classes}
    min={minAmount}
    max={maxAmount}
    defaultValue={selectedIndex ? selectedIndex : 0}
    marks={markers}
    step={continuousDrag ? .1 : 1}
    included={continuousValues}
    onAfterChange={onChangeCallback}
    disabled={disabled}
  />;
};


const AnswerOptionShape = PropTypes.shape({
  label: PropTypes.any,
  value: PropTypes.any
});
Slider.propTypes = {
  className: PropTypes.string,
  extended: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  continuousDrag: PropTypes.bool,
  continuousValues: PropTypes.bool,
  selected: PropTypes.any,
  answerOptions: PropTypes.arrayOf(AnswerOptionShape).isRequired
};

export default Slider;
